import {
  FaHotel,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaArrowRight,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaCheckCircle,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import img from "../assests/images/South-Travels-Footer-Logo.png";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-[#002B45] text-white">

      {/* Decorative Background */}
      <div className="absolute -top-40 -right-40 w-[450px] h-[450px] rounded-full bg-[#D4A83F]/10 blur-3xl"></div>

      <div className="absolute -bottom-40 -left-40 w-[450px] h-[450px] rounded-full bg-[#174B5F]/30 blur-3xl"></div>

      {/* ================= MAIN FOOTER ================= */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 sm:pt-16 pb-10">

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-12">

          {/* Brand */}
          <div className="lg:col-span-4">

            <Link
              to="/"
              className="inline-flex items-center group"
            >
              <img
                src={img}
                alt="Jumeira Discount Hotels"
                className="
    w-auto
    h-14 sm:h-16
    max-w-[240px]
    object-contain
    transition-all
    duration-300
    group-hover:scale-105
"
              />
            </Link>

            <p className="text-slate-300 text-sm leading-7 mt-6 max-w-sm">
              Discover premium hotels, unbeatable deals and
              unforgettable stays across Dubai. We make finding
              your perfect accommodation simple.
            </p>



            {/* Social */}
            <div className="flex items-center gap-3 mt-7">

              <a
                href="https://www.facebook.com/SouthTravelsOfficialPage/"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#D4A83F] hover:text-[#002B45] transition"
              >
                <FaFacebookF className="text-sm" />
              </a>

              <a
                href="https://www.instagram.com/southtravels8376/"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#D4A83F] hover:text-[#002B45] transition"
              >
                <FaInstagram className="text-sm" />
              </a>

              <a
                href="https://x.com/SouthTravels"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#D4A83F] hover:text-[#002B45] transition"
              >
                <FaTwitter className="text-sm" />
              </a>

              <a
                href="https://www.linkedin.com/company/southtravelsuae/"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#D4A83F] hover:text-[#002B45] transition"
              >
                <FaLinkedinIn className="text-sm" />
              </a>

            </div>

          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">

            <h4 className="text-sm font-bold uppercase tracking-wider text-white mb-5">
              Explore
            </h4>

            <ul className="space-y-3">

              <li>
                <Link
                  to="/"
                  className="text-sm text-slate-300 hover:text-[#D4A83F] transition"
                >
                  Home
                </Link>
              </li>

              <li>
                <Link
                  to="/hotels"
                  className="text-sm text-slate-300 hover:text-[#D4A83F] transition"
                >
                  Hotels
                </Link>
              </li>

              <li>
                <Link
                  to="/destinations"
                  className="text-sm text-slate-300 hover:text-[#D4A83F] transition"
                >
                  Destinations
                </Link>
              </li>

              <li>
                <Link
                  to="/blogs"
                  className="text-sm text-slate-300 hover:text-[#D4A83F] transition"
                >
                  Travel Guides
                </Link>
              </li>

            </ul>

          </div>

          {/* Company */}
          <div className="lg:col-span-2">

            <h4 className="text-sm font-bold uppercase tracking-wider text-white mb-5">
              Company
            </h4>

            <ul className="space-y-3">

              <li>
                <Link
                  to="/about-us"
                  className="text-sm text-slate-300 hover:text-[#D4A83F] transition"
                >
                  About Us
                </Link>
              </li>

              <li>
                <Link
                  to="/contact-us"
                  className="text-sm text-slate-300 hover:text-[#D4A83F] transition"
                >
                  Contact Us
                </Link>
              </li>

              <li>
                <Link
                  to="/privacy-policy"
                  className="text-sm text-slate-300 hover:text-[#D4A83F] transition"
                >
                  Privacy Policy
                </Link>
              </li>

              <li>
                <Link
                  to="/terms"
                  className="text-sm text-slate-300 hover:text-[#D4A83F] transition"
                >
                  Terms & Conditions
                </Link>
              </li>

            </ul>

          </div>

          {/* Contact */}
          <div className="lg:col-span-4">

            <h4 className="text-sm font-bold uppercase tracking-wider text-white mb-5">
              Get In Touch
            </h4>

            <div className="space-y-4">

              <div className="flex items-start gap-3">

                <div className="w-10 h-10 shrink-0 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
                  <FaMapMarkerAlt className="text-[#D4A83F] text-sm" />
                </div>

                <div>
                  <p className="text-xs text-slate-400">
                    Location
                  </p>

                  <p className="text-sm text-slate-200 mt-1">
                    Office 302, 3rd Flr. HDS Tower Cluster F, Jumeirah Lakes Towers Dubai
                  </p>
                </div>

              </div>

              <div className="flex items-start gap-3">

                <div className="w-10 h-10 shrink-0 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
                  <FaPhoneAlt className="text-[#D4A83F] text-sm" />
                </div>

                <div>
                  <p className="text-xs text-slate-400">
                    Phone
                  </p>

                  <a
                    href="tel:+971000000000"
                    className="text-sm text-slate-200 mt-1 block hover:text-[#D4A83F] transition"
                  >
                    +971 00 000 0000
                  </a>
                </div>

              </div>

              <div className="flex items-start gap-3">

                <div className="w-10 h-10 shrink-0 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
                  <FaEnvelope className="text-[#D4A83F] text-sm" />
                </div>

                <div>
                  <p className="text-xs text-slate-400">
                    Email
                  </p>

                  <a
                    href="mailto:info@beachhotelsdubai.com"
                    className="text-sm text-slate-200 mt-1 block hover:text-[#D4A83F] transition"
                  >
                    info@beachhotelsdubai.com
                  </a>
                </div>

              </div>

            </div>

          </div>

        </div>

        {/* Divider */}
        <div className="h-px bg-white/10 mt-12"></div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-6 text-center md:text-left">

          <p className="text-xs sm:text-sm text-slate-400">
            © {new Date().getFullYear()} Jumeira Discount Hotels. All rights reserved.
          </p>

          <div className="flex items-center gap-5">

            <Link
              to="/privacy-policy"
              className="text-xs sm:text-sm text-slate-400 hover:text-white transition"
            >
              Privacy
            </Link>

            <Link
              to="/terms"
              className="text-xs sm:text-sm text-slate-400 hover:text-white transition"
            >
              Terms
            </Link>

            <Link
              to="/contact-us"
              className="text-xs sm:text-sm text-slate-400 hover:text-white transition"
            >
              Contact
            </Link>

          </div>

        </div>

      </div>

    </footer>
  );
}